import { SideListOptionType } from '@fi-shared/types';
import { FiTasksViewMode } from '@fi-shared/fi-task-shared/fi-task-enums';
import { FiTaskSharedService } from '@fi-shared/fi-task-shared/fi-task-shared.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FiTaskV2HelperService } from './fi-task-v2-helper.service';

@Injectable()
export class FiTaskV2SyncService {
    constructor(
        private fiTaskService: FiTaskSharedService,
        private fiTaskV2HelperService: FiTaskV2HelperService,
    ) {}

    private _privateTasksCount$ = new BehaviorSubject<number>(0);
    get privateTasksCount$(): Observable<number> {
        return this._privateTasksCount$.asObservable();
    }

    get privateTasksCount(): number {
        return this._privateTasksCount$.value;
    }

    private _assignedToMeTasksCount$ = new BehaviorSubject<number>(0);
    get assignedToMeTasksCount$(): Observable<number> {
        return this._assignedToMeTasksCount$.asObservable();
    }

    get assignedToMeTasksCount(): number {
        return this._assignedToMeTasksCount$.value;
    }

    private _assignedByMeTasksCount$ = new BehaviorSubject<number>(0);
    get assignedByMeTasksCount$(): Observable<number> {
        return this._assignedByMeTasksCount$.asObservable();
    }

    get assignedByMeTasksCount(): number {
        return this._assignedByMeTasksCount$.value;
    }

    private _allTasksCount$ = new BehaviorSubject<number>(0);
    get allTasksCount$(): Observable<number> {
        return this._allTasksCount$.asObservable();
    }

    get allTasksCount(): number {
        return this._allTasksCount$.value;
    }

    loadTasksCountForTabs(tasksViewMode: FiTasksViewMode) {
        const parameter = this.fiTaskV2HelperService.getUpdatedTaskParameter(
            {},
            {},
            {
                filterType: SideListOptionType.All,
                isArchived: tasksViewMode === FiTasksViewMode.archived,
                taskStatuses: this.fiTaskV2HelperService.getTaskStatusFilterByViewMode(tasksViewMode),
            },
        );
        const isTaskV2 = this.fiTaskV2HelperService.getNormalizedTaskV2();
        return this.fiTaskService.getTasksCountForTabs(parameter, isTaskV2).then((result) => {
            result.forEach((countItem) => {
                const filterType = countItem.FilterType;
                if (filterType === SideListOptionType.TasksPrivate) {
                    this._privateTasksCount$.next(countItem.TasksCount);
                } else if (filterType === SideListOptionType.TasksAssignedToMe) {
                    this._assignedToMeTasksCount$.next(countItem.TasksCount);
                } else if (filterType === SideListOptionType.TasksAssignedByMe) {
                    this._assignedByMeTasksCount$.next(countItem.TasksCount);
                } else {
                    throw new Error(`Unknown filterType in loadTasksCountForTabs ${filterType}`);
                }
            });
            this._allTasksCount$.next(result.reduce((acc, curr) => acc + curr.TasksCount, 0));
        });
    }
}
